/**
 * The Suspense boundary for lazy-loaded routes (the app's first: the book pages, ebook-plan
 * § 3.13), with a small translated loading state. It sits inside the layout, so the header,
 * the nav and the audio player stay on screen while the route's code loads.
 */
import { Suspense, type ReactNode } from 'react';
import { BookLoading } from '@/components/features/book/BookLoading';

export function LazyRoute({ children }: { children: ReactNode }) {
  return <Suspense fallback={<BookLoading />}>{children}</Suspense>;
}
